import React from 'react'
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell
} from 'recharts';

const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

function ProjectAnalysisChart({ projects, filterActive = true }) {
  const dataSource = filterActive
    ? projects.filter((p) => p.is_active === true || p.is_active === 1)
    : projects;

  const data = DAYS.map((day, i) => ({
    day,
    value: dataSource.filter((p) => {
      if (!p.createdAt) return false;
      return new Date(p.createdAt).getDay() === i;
    }).length,
  }));

  const maxVal = Math.max(...data.map((d) => d.value), 1);

  return (
    <div className="panel">
      <div className="panel__header">
        <h3 className="panel__title">Project Analytics</h3>
      </div>
      <ResponsiveContainer width="100%" height={240}>
        <BarChart data={data} barCategoryGap="30%">
          <CartesianGrid vertical={false} stroke="#E5E7EB" strokeDasharray="3 3" />
          <XAxis
            dataKey="day"
            tick={{ fill: '#6B7280', fontSize: 12 }}
            axisLine={false}
            tickLine={false}
          />
          <YAxis hide />
          <Tooltip
            contentStyle={{
              background: '#fff',
              border: 'none',
              borderRadius: 6,
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
            }}
            cursor={{ fill: 'rgba(249, 115, 22, 0.05)' }}
          />
          <Bar dataKey="value" radius={[6, 6, 0, 0]}>
            {data.map((entry, index) => (
              <Cell
                key={index}
                fill={
                  entry.value === maxVal
                    ? '#F97316'
                    : '#FB923C'
                }
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export default ProjectAnalysisChart
